import React from 'react';

const Ghost = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="69"
    viewBox="0 0 70 69"
  >
    <defs>
      <path
        id="b1m5acg8la"
        d="M1.351.02C.605.02 0 .623 0 1.364s.605 1.342 1.351 1.342h2.793c.515 0 .935.417.935.929 0 1.992 1.632 3.613 3.638 3.613h2.41c.746 0 1.352-.6 1.352-1.342 0-.741-.606-1.342-1.352-1.342h-2.41c-.516 0-.935-.417-.935-.929C7.782 1.641 6.15.021 4.144.021H1.35z"
      />
      <path
        id="29w23z6i0c"
        d="M13.577.081C6.393.08.315 6.072.14 13.181c-.166 7.614-.055 15.132 1.214 22.66.606 2.993 1.374 5.883 2.35 8.78.41 1.144 1.734 2.07 2.897 2.07h.211c1.163 0 1.678-.907 1.222-2.033-.312-.768.083-1.384.85-1.374.768.011 1.63.64 1.963 1.399.487 1.113 1.888 2.008 3.051 2.008h.212c1.163 0 1.601-.876 1.067-1.97-.364-.747-.005-1.35.762-1.339.768.01 1.667.624 2.052 1.363.564 1.082 2.042 1.946 3.205 1.946h.212c1.163 0 1.524-.845.913-1.908-.417-.726-.094-1.313.673-1.303.767.01 1.703.61 2.14 1.327.642 1.051 2.197 1.884 3.36 1.884h.106c1.221 0 1.519-.855.802-1.94-1.596-2.631-2.73-5.217-3.597-8.158-1.714-7.71-.996-15.331-.116-23.103C26.554 6.198 20.96.081 13.583.081h-.006"
      />
      <linearGradient id="iqmwvwbztd" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#98B0FD" />
        <stop offset="100%" stopColor="#2D60FB" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            fill="#D7EFF3"
            fillRule="nonzero"
            d="M55.17 18.088c3.753 5.66 3.364 13.847 1.256 20.879-2.108 7.046-5.906 12.937-11.907 16.93-6.001 3.995-14.192 6.077-19.189 2.96-4.983-3.117-6.772-11.448-9.342-20.29-2.556-8.842-5.893-18.21-2.758-23.685 3.15-5.49 12.758-7.085 21.517-6.322 8.759.762 16.655 3.882 20.423 9.528z"
            transform="translate(-438 -94) translate(438 94) rotate(52 34.983 34.372)"
          />
          <g>
            <g transform="translate(-438 -94) translate(438 94) translate(15 10) translate(0 24.78)">
              <mask id="c1cssajckb" fill="#fff">
                <use href="#b1m5acg8la" />
              </mask>
              <path
                fill="#97AEFF"
                d="M1.351.02C.605.02 0 .623 0 1.364s.605 1.342 1.351 1.342h2.793c.515 0 .935.417.935.929 0 1.992 1.632 3.613 3.638 3.613h2.41c.746 0 1.352-.6 1.352-1.342 0-.741-.606-1.342-1.352-1.342h-2.41c-.516 0-.935-.417-.935-.929C7.782 1.641 6.15.021 4.144.021H1.35z"
                mask="url(#c1cssajckb)"
              />
            </g>
            <g transform="translate(-438 -94) translate(438 94) translate(15 10) translate(5.495 .12)">
              <mask id="12rze9ybqe" fill="#fff">
                <use href="#29w23z6i0c" />
              </mask>
              <path
                fill="url(#iqmwvwbztd)"
                d="M13.577.081C6.393.08.315 6.072.14 13.181c-.166 7.614-.055 15.132 1.214 22.66.606 2.993 1.374 5.883 2.35 8.78.41 1.144 1.734 2.07 2.897 2.07h.211c1.163 0 1.678-.907 1.222-2.033-.312-.768.083-1.384.85-1.374.768.011 1.63.64 1.963 1.399.487 1.113 1.888 2.008 3.051 2.008h.212c1.163 0 1.601-.876 1.067-1.97-.364-.747-.005-1.35.762-1.339.768.01 1.667.624 2.052 1.363.564 1.082 2.042 1.946 3.205 1.946h.212c1.163 0 1.524-.845.913-1.908-.417-.726-.094-1.313.673-1.303.767.01 1.703.61 2.14 1.327.642 1.051 2.197 1.884 3.36 1.884h.106c1.221 0 1.519-.855.802-1.94-1.596-2.631-2.73-5.217-3.597-8.158-1.714-7.71-.996-15.331-.116-23.103C26.554 6.198 20.96.081 13.583.081h-.006"
                mask="url(#12rze9ybqe)"
              />
            </g>
            <g>
              <path
                fill="#1C2B6B"
                d="M.642 5.123C1.91 6.01 3.973 4.436 2.97.93 2.92.755 2.665.71 2.585.9 1.668 3.084-.867 4.064.642 5.123M6.364.15c-1.515.635 1.2 9.054 5.417 6.399 2.57-1.618.251-3.206-2.357-4.167C7.842 1.799 7.275-.233 6.364.15M7.64 9.336c0 1.597-.894 2.891-1.997 2.891-1.103 0-1.998-1.294-1.998-2.89 0-1.597.895-2.892 1.998-2.892S7.641 7.74 7.641 9.336"
                transform="translate(-438 -94) translate(438 94) translate(15 10) translate(7.53 10.833)"
              />
              <path
                fill="#97AEFF"
                d="M10.963 21.194c-2.006 0-3.638-1.621-3.638-3.613 0-.513-.42-.93-.935-.93H3.597c-.746 0-1.35-.6-1.35-1.342 0-.74.604-1.342 1.35-1.342H6.39c2.006 0 3.638 1.621 3.638 3.614 0 .512.42.928.935.928h2.41c.746 0 1.352.601 1.352 1.343 0 .74-.606 1.342-1.352 1.342h-2.41z"
                transform="translate(-438 -94) translate(438 94) translate(15 10) translate(7.53 10.833)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Ghost;
